import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

const ContestQualificationMapCheckImages = ({ srcList }) =>
  !!srcList.length && (
    <Box>
      <Grid
        container
        spacing={2}
      >
        {srcList.map((src) => (
          <Grid
            key={src}
            item
            xs={3}
          >
            <img
              loading="lazy"
              src={src}
              alt=""
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  )

export default ContestQualificationMapCheckImages
